import { configureStore } from '@reduxjs/toolkit';
import dashboardReducer from '../features/dashboard/dashboardSlice';
import threatsReducer from '../features/threats/threatsSlice';
import detectionEngineeringReducer from '../features/threats/detectionEngineeringSlice';
import vulnReducer from '../features/vulnerabilities/vulnSlice';
import identityReducer from '../features/identity/identitySlice';
import endpointReducer from '../features/endpoint/endpointSlice';
import emailReducer from '../features/email/emailSlice';
import pentestReducer from '../features/pentest/pentestSlice';
import aiReducer from '../features/ai/aiSlice';
import networkDiscoveryReducer from '../features/network-discovery/networkDiscoverySlice';
import malwareAnalysisReducer from '../features/malware-analysis/malwareAnalysisSlice';
import automationReducer from '../features/automation/automationSlice';
import incidentsReducer from '../features/incidents/incidentsSlice';
import ticketsReducer from '../features/tickets/ticketsSlice';
import notificationsReducer from '../features/notifications/notificationsSlice';
import auditLogsReducer from '../features/audit-logs/auditLogsSlice';
import platformSettingsReducer from '../features/settings/settingsSlice';
import organizationsReducer from '../features/organizations/organizationsSlice';
import businessAssetsReducer from '../features/assets/assetsSlice';
import threatIntelReducer from '../features/threat-intel/threatIntelSlice';
import threatMonitoringReducer from '../features/threat-monitoring/threatMonitoringSlice';
import vulnManagementReducer from '../features/vuln-management/vulnManagementSlice';
import socReducer from '../features/soc/socSlice';
import simLabReducer from '../features/simlab/simLabSlice';
import reportsReducer from '../features/reports/reportsSlice';
import complianceReducer from '../features/compliance/complianceSlice';
import policiesReducer from '../features/policies/policiesSlice';
import schedulerReducer from '../features/scheduler/schedulerSlice';
import licensingReducer from '../features/licensing/licensingSlice';
import portalAuthReducer from '../portal/slices/portalAuthSlice';
import portalReducer from '../portal/slices/portalSlice';

export const store = configureStore({
  reducer: {
    dashboard: dashboardReducer,
    threats: threatsReducer,
    detectionEngineering: detectionEngineeringReducer,
    vulnerabilities: vulnReducer,
    identity: identityReducer,
    endpoint: endpointReducer,
    email: emailReducer,
    pentest: pentestReducer,
    ai: aiReducer,
    networkDiscovery: networkDiscoveryReducer,
    malwareAnalysis: malwareAnalysisReducer,
    automation: automationReducer,
    incidents: incidentsReducer,
    tickets: ticketsReducer,
    notifications: notificationsReducer,
    auditLogs: auditLogsReducer,
    platformSettings: platformSettingsReducer,
    organizations: organizationsReducer,
    businessAssets: businessAssetsReducer,
    threatIntel: threatIntelReducer,
    threatMonitoring: threatMonitoringReducer,
    vulnManagement: vulnManagementReducer,
    soc: socReducer,
    simLab: simLabReducer,
    reports: reportsReducer,
    compliance: complianceReducer,
    policies: policiesReducer,
    scheduler: schedulerReducer,
    licensing: licensingReducer,
    portalAuth: portalAuthReducer,
    portal: portalReducer
  }
});

export default store;
